import * as d3 from 'd3'

export const MAP_LEGENDS  = {
    'clasificacion_de_pendiente': [
        { min: 4, label: '> 50°', color: '#800026' },
        { min: 3, label: '30° - 50°', color: '#E31A1C' },
        { min: 2, label: '15° - 30°', color: '#FD8D3D' },
        { min: 1, label: '5° -15°', color: '#FED976' },
        { min: 0, label: '0° - 5°', color: '#FFFFCC' },
        { min: -1, label: 'No Data', color: 'lightgrey' } ],
    'ind_vul': [
        // { min: 80, label: '> 80', color: '#800026' },
        { min: 72.1, label: '72.1 - 94.07', color: '#FF0000' },
        { min: 49.94, label: '49.94 - 72', color: '#FFAA00' },
        { min: 27.87, label: '27.87 - 49.93', color: '#FFFf00' },
        { min: 5.79, label: '5.79 - 27.86', color: '#98E600' },
        { min: -1, label: 'No Data', color: 'lightgrey' }
    ],
    'indice_envejecimiento': [
     //   { min: 999, label: '> 999', color: '#810f7c' },
        { min: 76, label: '76% - 100%', color: '#88419D' },//4= 2,51-10 (#88419D)
        { min: 51, label: '51% - 75%', color: '#8C96C6' },//3= 1,51-2,5 (#8C96C6)
        { min: 26, label: '26% - 50%', color: '#B3CDE3' },//2= 1,0-1,5 (#B3CDE3)
        { min: 1, label: '0 - 25%', color: '#EDF8FB' },// 1= 0-1,0 (#EDF8FB)
        { min: -1, label: 'No Data', color: 'lightgrey' }
    ],
    'deficit_de_equipamientos_valor': [
        { min: 0.9, label: 'Equipamiento', color: '#BED2FF' },
        { min: -0.1, label: 'Sin Equipamiento', color: '#9C9C9C' },
        { min: -1, label: 'No Data', color: 'lightgrey' }
    ],
    'deficit_de_vegetacion_promedio': [
        // Note: Since your logic used "<", these are inverted to match the .find(d > min) logic
        // { min: 0.897, label: '> 0.89', color: 'lightgrey' },
        // { min: 0.728, label: '0.73 - 0.89', color: '#C6E2B2' },
        // { min: 0.631, label: '0.63 - 0.72', color: '#E4EDC2' },
        // { min: -0.1, label: '0.00 - 0.63', color: '#F2D08E' }
        { min: 0.897, label: '> 0.89', color: 'lightgrey' },
        { min: 0.728, label: '0.73 - 0.89', color: '#C6E2B2' },
        { min: 0.631, label: '0.63 - 0.72', color: '#E4EDC2' },
        { min: -0.1, label: '0.00 - 0.63', color: '#F2D08E' }
    ],
    'densidad_urbana_promedio': [
        { min: 0.545, label: '0.55 - 1.00', color: '#F50000' },
        { min: 0.378, label: '0.38 - 0.54', color: '#F53D00' },
        { min: 0.273, label: '0.27 - 0.37', color: '#F57A00' },
        { min: 0.079, label: '0.08 - 0.26', color: '#F5B800' },
        { min: -0.1, label: '< 0.08', color: '#F5F500' }
    ],
    'id_use': [
        { min: 6.9, label: 'Sin uso definido', color: '#E5C494' },
        { min: 5.9, label: 'Servicios públicos', color: '#FFD92E' },
        { min: 4.9, label: 'Venta al por menor', color: '#A7D854' },
        { min: 3.9, label: 'Oficinas', color: '#E68AC2' },
        { min: 2.9, label: 'Industrial', color: '#8DA0CB' },
        { min: 1.9, label: 'Agricultura', color: '#FC8D62' },
        { min: 0.9, label: 'Residencial', color: '#66C2A5' },
        { min: -1, label: 'Otros', color: 'lightgrey' }
    ],
    'peatonal_bus_clase' : [
        { min: 4, label: '> 30 min', color: '#FFFFE5' },
        { min: 3, label: '15 - 30 min', color: '#D9F0A3' },
        { min: 2, label: '10 - 15 min', color: '#78C679' },
        { min: 1, label: '5 - 10 min', color: '#238443' },
        { min: 0, label: '< 5 min', color: '#00442A' },
        { min: -1, label: 'Sin Datos', color: 'lightgrey' }
    ],
    'coche_educacion_clase' : [
        { min: 4, label: '> 15 min', color: '#FFFFE5' },
        { min: 3, label: '10 - 15 min', color: '#D9F0A3' },
        { min: 2, label: '6 - 10 min', color: '#78C679' },
        { min: 1, label: '3 - 6 min', color: '#238443' },
        { min: 0, label: '< 3 min', color: '#00442A' },
        { min: -1, label: 'Sin Datos', color: 'lightgrey' }
    ],
    'coche_salud_clase': [
        { min: 4, label: '> 15 min', color: '#FFFFE5' },
        { min: 3, label: '10 - 15 min', color: '#D9F0A3' },
        { min: 2, label: '6 - 10 min', color: '#78C679' },
        { min: 1, label: '3 - 6 min', color: '#238443' },
        { min: 0, label: '< 3 min', color: '#00442A' },
        { min: -1, label: 'Sin Datos', color: 'lightgrey' }
    ],
    'distancia_peatonal': [
        { min: 4, label: '> 30 min', color: '#FFFFE5' },
        { min: 3, label: '15 - 30 min', color: '#D9F0A3' },
        { min: 2, label: '10 - 15 min', color: '#78C679' },
        { min: 1, label: '5 - 10 min', color: '#238443' },
        { min: 0, label: '< 5 mim', color: '#00442A' },
        { min: -1, label: 'Sin Datos', color: 'lightgrey' }
    ],
    'habitantes_por_parcela_promedio': [
        // { min: 15, label: '> 7.33 Hab', color: '#00441C' },
        // { min: 3.8, label: '3.8 - 7.33 Hab', color: '#006D2C' },
        { min: 4.51, label: '4.51 - 22.25 Hab', color: '#006D2C' },
        { min: 3.1, label: '3.1 - 4.5 Hab', color: '#2CA25F' },
        { min: 2.1, label: '2.1 - 3.0 Hab', color: '#B2E2E2' },
        { min: 0.2, label: '0.2 - 2.0 Hab', color: '#EDF8FB' },
        { min: -0.1, label: 'Sin Datos', color: 'lightgrey' }
    ],
    'poblacion_total_en_calle': [
        { min: 400, label: '> 300 Hab', color: '#00441C' },
        { min: 300, label: '201 - 300 Hab', color: '#006D2C' },
        { min: 200, label: '101 - 200 Hab', color: '#238B44' },
        { min: 80, label: '51 - 100 Hab', color: '#41AE76' },
        { min: 20, label: '26 - 50 Hab', color: '#66C2A4' },
        { min: 10, label: '1 - 25 Hab', color: '#99D8C9' },
        { min: -0.1, label: 'Sin Datos', color: 'lightgrey' }
    ],
    'idx_acceso': [
        // Representing the D3 interpolation as discrete steps for the Legend
        { min: 0.93, label: '93% - 100%', color: '#f7fcf0' },
        { min: .82, label: '82% - 92%', color: '#d9f0d4' },
        { min: .73, label: '73% - 81%', color: '#b4e2ba' },
        { min: .63, label: '63% - 72%%', color: '#7bccc4' },
        { min: .5, label: '50% - 62%', color: '#42a6cc' },
        { min: .31, label: '31% - 49%', color: '#1478b2' },
        { min: .03, label: '3% - 30%', color: '#084081' }
        // { min: 13.683, label: '13.683 - 19.228', color: '#084081' },
        // { min: 9.912, label: '9.912 - 13.682', color: '#1478b2' },
        // { min: 7.469, label: '7.469 - 9.911', color: '#42a6cc' },
        // { min: 5.444, label: '5.444 - 7.468', color: '#7bccc4' },
        // { min: 3.602, label: '3.602 - 5.443', color: '#b4e2ba' },
        // { min: 1.442, label: '1.442 - 3.601', color: '#d9f0d4' },
        // { min: -0.01, label: '0 - 1.441', color: '#f7fcf0' }
    ],
    'idx_iicu': [
        // Representing the D3 interpolation as discrete steps for the Legend
        { min: .7975, label: '79.75% - 91% : Muy Alta', color: '#ffffbf' },
        { min: .69, label: '69.01% - 79%: Alta', color: '#b5e29b' },
        { min: .59, label: '59.01% - 69%: Media', color: '#7bc48e' },
        { min: .49, label: '49.01% - 59%: Baja', color: '#5ea79f' },
        { min: 28.5, label: '28.5% - 49%: Muy Baja', color: '#e1e1e1' }
    ],
    'idx_urbano': [
        // Representing the D3 interpolation as discrete steps for the Legend
        { min: .71, label: '71% - 100% : Muy Alta', color: '#43a2ca' },
        { min: .60, label: '60% - 70%: Alta', color: '#7bccc4' },
        { min: .44, label: '44% - 59%: Media', color: '#a8ddb5' },
        { min: .29, label: '29% - 43%: Baja', color: '#ccebc5' },
        { min: 0, label: '0% - 28%: Muy Baja', color: '#F0f9e8' }
    ],
    'indice_dependencia': [
        { min: 100, label: '> 100%', color: '#670020' },
        { min: 80, label: '81 - 100%', color: '#B2182B' },
        { min: 60, label: '61 - 80%', color: '#D6604D' },
        { min: 40, label: '41 - 60%', color: '#F4A582' },
        { min: 20, label: '21 - 40%', color: '#FDDBC7' },
        { min: -0.1, label: '0 - 20%', color: '#FFEDA0' }
    ],
    'indice_dependencia_de_menor_15': [
    //    { min: 79, label: '> 79%', color: '#08306b' },
        { min: 76, label: '76 - 100%', color: '#2171B5' },//4= 0,76-1 (#2171B5)
        { min: 51, label: '51 - 75%', color: '#6BAED6' },//3=0,51-0,75 (#6BAED6)
        { min: 26, label: '26 - 50%', color: '#BDD7E7' },// 2= 0,26-0,50 (#BDD7E7)
        { min: 1, label: '1 - 25%', color: '#EFF3FF' },// 1= 0-0,25 (#EFF3FF)
        { min: -1, label: 'Sin Datos', color: 'lightgrey' }
    ],
    'indice_dependencia_de_mayor_65': [
        // { min: 200, label: '> 200%', color: '#08306b' },
        { min: 76, label: '76 - 100%', color: '#2171B5' },
        { min: 51, label: '51 - 75%', color: '#6BAED6' },
        { min: 26, label: '26 - 50%', color: '#BDD7E7' },
        { min: 1, label: '1 - 25%', color: '#EFF3FF' },
        { min: -1, label: 'Sin Datos', color: 'lightgrey' }
        ]
}

const getColor = (view, value) => {
    // Find the first threshold where the value is greater than the min
    const theme = MAP_LEGENDS[view]
    const match = theme.find(threshold => value > threshold.min);
    return match ? match.color : 'lightgrey';
    // return  d > 100 ? '#670020' :
    //     d > 80  ? '#B2182B' :
    //         d > 60  ? '#D6604D' :
    //             d > 40  ? '#F4A582' :
    //                 d > 20  ? '#FDDBC7' :
    //                     '#FFEDA0'; // Default color
}

const getColorDependencia_15 = d => {
    return  d > 79 ? '#08306b' :
        d > 59 ? '#2979b9' :
            d > 39 ? '#73b2d8' :
                d > 19 ? '#c8dcf0' :
                    d > 0  ? '#f7fbff':
                        'lightgrey'; // Default color
}

const getColorDependencia_65 = d => {
    return  d > 200 ? '#08306b' :
        d > 99 ? '#2979b9' :
            d > 49 ? '#73b2d8' :
                d > 24 ? '#c8dcf0' :
                    d > 0  ? '#f7fbff':
                        'lightgrey'; // Default color
}

const getColorEnvejecimiento = d => {
    return  d > 999 ? '#810f7c' :
        d > 299 ? '#8856a7' :
            d > 199 ? '#8c96c6' :
                d > 99 ? '#b3cde3' :
                    d > 0  ? '#edf8fb' :
                        'lightgrey'; // Default color
}

const getColorIncome = d => {
    return  d > 28000 ? '#810f7c' :
        d > 27000 ? '#8856a7' :
            d > 26000 ? '#8c96c6' :
                d > 24000 ? '#b3cde3' :
                    d > 0  ? '#edf8fb' :
                        'lightgrey'; // Default color
}

const getColorIV = d => {
    return  d > 80 ? '#800026' :
        d > 60 ? '#E31A1C' :
            d > 40 ? '#FD8D3D' :
                d > 20 ? '#FED976' :
                    d > 0  ? '#FFFFCC' :
                        'lightgrey'; // Default color
}

const getColorSlope = d => {
    return  d > 4 ? '#800026' :
        d > 3 ? '#E31A1C' :
            d > 2 ? '#FD8D3D' :
                d > 1 ? '#FED976' :
                    d > 0  ? '#FFFFCC' :
                        'lightgrey'; // Default color
}

const getColorDeficitEquipamientos = d => {
    return  d == 0 ? '#9C9C9C' :
        d == 1 ? '#BED2FF':
                        'lightgrey'; // Default color
}

const getColorDeficitVegetacion = d => {
    return d < .631728 ? '#F2D08E':
        d < .728260 ? '#E4EDC2':
     d < .897308 ? '#C6E2B2' :
                'lightgrey'
}

const getColorDensidadUrbana = d => {
    return d < .079034 ? '#F5F500':
        d < .273599 ? '#F5B800':
            d < .378686 ? '#F57A00':
                d < .545833 ? '#F53D00':
                    d < 1.000003 ? '#F50000' :
                'lightgrey'
}

const getColorUsosDeSuelo = d => {
    return d == 1 ? '#66C2A5':
        d == 2 ? '#FC8D62':
            d == 3 ? '#8DA0CB':
                d== 4 ? '#E68AC2':
                    d == 5 ? '#A7D854' :
                        d == 6 ? '#FFD92E' :
                            d == 7 ? '#E5C494' :
                                'lightgrey'
}

const getIsochronesSports = d => {
    return  d > 4 ? '#FFFFE5' :
        d > 3 ? '#D9F0A3' :
            d > 2 ? '#78C679' :
                d > 1 ? '#238443' :
                    d > 0  ? '#00442A' :
                        'lightgrey'; // Default color
}

const getHabitantesPorParcela = d => {
    return  d > 15 ? '#00441C' :
        d > 10 ? '#006D2C' :
            d > 5 ? '#238B44' :
                d > 2 ? '#41AE76' :
                    d > 1 ? '#66C2A4':
                        d > 0  ? '#99D8C9' :
                        d == null ? 'lightgrey':
                        'darkgrey'; // Default color
}

const getHabitantesPorCalle = d => {
    return  d > 300 ? '#00441C' :
        d > 200 ? '#006D2C' :
            d > 100 ? '#238B44' :
                d > 50 ? '#41AE76' :
                    d > 25 ? '#66C2A4':
                        d > 0  ? '#99D8C9' :
                            d == null ? 'lightgrey':
                                'darkgrey'; // Default color
}

const getColorIAEU = d => {
    const cat = [
        "Deportes",
        "Medio ambiente y espacios públicos",
        "Administración pública i servicios públicos",
        "Salud y bienestar social",
        "Cultura y comunidad",
        "Educación"
    ]
    const cal = ['#4269D0', '#EFB116', '#FF725C', '#6CC5B0', '#3DA951', '#FF8AB7']

    const colorScale = d3.scaleOrdinal()
        .domain(cat)
        // .domain([25, 0])
        .range(cal)
    return colorScale(d)
}

const segmentColors = (_, d) => {
    const colorScale = d3.scaleSequential()
        .domain([100, 0])
        .interpolator(d3.interpolateCool)
    return colorScale(d)
}

export const styleRegistryLines = ({
    'clasificacion_de_pendiente': feature => {
        return {
            fillColor: 'red',
            weight: 1,
            opacity: 1,
            color: 'white',
            fillOpacity: 0.7,
        }
    },
    'habitantes_por_parcela_promedio': feature => {
        const viewName = feature.properties['poblacion_total_en_calle']
        return {
            // fillColor: 'none',
            weight: 2,
            opacity: 1,
            color: getColor('poblacion_total_en_calle', viewName),
            fillOpacity: 0.7,
        }
    },
    'default': feature => {
        const colorPolygon = d => d.categoria ? getColorIAEU(d.categoria) : '#EFF5FF'
        const opacity = d => d.categoria ? 1 : 0
      //  const colors = ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00']; // Your 5 colors
        // const uniqueCategories = [...new Set(feature.map(f => f.properties.id_barrio))];
        // console.log(uniqueCategories)
        return {
            fillColor: colorPolygon(feature.properties),
            weight: 2,
            opacity: 1,
            color: 'grey',
            fillOpacity: opacity(feature.properties),
        };
    },
    'distancia_peatonal': feature => {
        const viewName = feature.properties['pendiente']
        return {
            color: getColor('clasificacion_de_pendiente', viewName),
            weight: 1,
            opacity: 1,
            fillOpacity: 1
        }
    },
    'peatonal_bus_clase': feature => {
        const viewName = feature.properties['pendiente']
        return {
            color: getColor('clasificacion_de_pendiente', viewName),
            weight: 1,
            opacity: 1,
            fillOpacity: 1
        }
    },
    'coche_educacion_clase': feature => {
        const viewName = feature.properties['pendiente']
        return {
            color: getColor('clasificacion_de_pendiente', viewName),
            weight: 1,
            opacity: 1,
            fillOpacity: 1
        }
    },
    'coche_salud_clase': feature => {
        const viewName = feature.properties['pendiente']
        return {
            color: getColor('clasificacion_de_pendiente', viewName),
            weight: 1,
            opacity: 1,
            fillOpacity: 1
        }
    },
    'indice_dependencia': feature => {
        const viewName = feature.properties['indice_dependencia_norm'] * 100
        return {
            color: getColor('indice_dependencia', viewName),
            weight: 2,
            opacity: 1,
            fillOpacity: 1
        }},
    'indice_dependencia_de_menor_15': feature => {
        const viewName = feature.properties['dep_15_norm'] * 100
        return {
            color: getColor('indice_dependencia_de_menor_15', viewName),
            weight: 2,
            opacity: 1,
            fillOpacity: 1
        }},
    'indice_dependencia_de_mayor_65': feature => {
        const viewName = feature.properties['dep_65_norm'] * 100
        return {
            color: getColor('indice_dependencia_de_mayor_65', viewName),
            weight: 2,
            opacity: 1,
            fillOpacity: 1
        }},
    'indice_envejecimiento': feature => {
        const viewName = feature.properties['envej_norm'] * 100
        return {
            color: getColor('indice_envejecimiento', viewName),
            weight: 2,
            opacity: 1,
            fillOpacity: 1
        }},
    'income': feature => {
        const viewName = feature.properties['y2023']
        return {
            color: getColor('y2023', viewName),
            weight: 2,
            opacity: 1,
            fillOpacity: 1
        }},
    'ind_vul': feature => {
        const viewName = feature.properties['ind_vul']
        return {
            color: 'red',
            weight: 2,
            opacity: 1,
            fillOpacity: 1
        }},
    'pein': feature => {
        const viewName = feature.properties['ind_vul']
        return {
            fillColor: '#C7E2B3',
            weight: 2,
            opacity: .3,
            fillOpacity: .3
        }},

})

export const styleRegistry = ({
    'clasificacion_de_pendiente': feature => {
        const viewName = feature.properties['clasificacion_de_pendiente']
        return {
            fillColor: getColor('clasificacion_de_pendiente', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .5
        }},
    'densidad_urbana_promedio': feature => {
        const viewName = feature.properties['densidad_urbana_promedio']
        return {
            fillColor: getColor('densidad_urbana_promedio', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .5
        }},
    'deficit_de_vegetacion_promedio': feature => {
        const viewName = feature.properties['deficit_de_vegetacion_promedio']
        return {
            fillColor: getColor('deficit_de_vegetacion_promedio', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'deficit_de_equipamientos_valor': feature => {
        const viewName = feature.properties['deficit_de_equipamientos_valor']
        return {
            fillColor: getColor('deficit_de_equipamientos_valor', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'id_use': feature => {
        const viewName = feature.properties['id_use']
        return {
            fillColor: getColor('id_use', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .5
        }},
    'distancia_peatonal': feature => {
        const viewName = feature.properties['distancia_peatonal']
        return {
            fillColor: getColor('distancia_peatonal', viewName),
            weight: 2,
            opacity: .5,
            color: 'none',  // Outline color
            fillOpacity: .75
        }},
    'habitantes_por_parcela_promedio': feature => {
    const viewName = feature.properties['habitantes_por_parcela_promedio']
    return {
        fillColor: getColor('habitantes_por_parcela_promedio', viewName),
            weight: 2,
            opacity: .7,
            color: 'none',  // Outline color
            fillOpacity: 1
    }},
    'indice_dependencia': feature => {
        const viewName = feature.properties['indice_dependencia'] * 100
        return {
            fillColor: getColor('indice_dependencia' ,viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'indice_dependencia_de_menor_15': feature => {
        const viewName = feature.properties['rank : indice de dependencia, menor de 15'] * 100
        return {
            fillColor: getColor('indice_dependencia_de_menor_15', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'indice_dependencia_de_mayor_65': feature => {
        const viewName = feature.properties['rank : indice de dependencia, mayor de 65'] * 100
        return {
            fillColor: getColor('indice_dependencia_de_mayor_65', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'indice_envejecimiento': feature => {
        const viewName = feature.properties['rank : indice de envejecimiento'] * 100
        return {
            fillColor: getColor('indice_envejecimiento', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'y2023': feature => {
        const viewName = feature.properties['y2023']
        return {
            fillColor: getColor('y2023', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'ind_vul': feature => {
        const viewName = feature.properties['ind_vul']
        return {
            fillColor: getColor('ind_vul', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: 1
        }},
    'idx_acceso': feature => {
        const viewName = feature.properties['indice acceso']
        return {
            // fillColor: segmentColors('idx_acceso', viewName),
            fillColor: getColor('idx_acceso', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .7
        }
    },
    'idx_urbano': feature => {
        const viewName = feature.properties['icu_']
        return {
            // fillColor: segmentColors('idx_acceso', viewName),
            fillColor: getColor('idx_urbano', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .7
        }
    },
    'idx_iicu': feature => {
        const viewName = feature.properties['valor de iicu']
        return {
            // fillColor: segmentColors('idx_acceso', viewName),
            fillColor: getColor('idx_iicu', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .7
        }
    },
    'peatonal_bus_clase': feature => {
        const viewName = feature.properties['peatonal_bus_clase']
        return {
            fillColor: getColor('peatonal_bus_clase', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .75
        }},
    'coche_educacion_clase': feature => {
        const viewName = feature.properties['coche_educacion_clase']
        return {
            fillColor: getColor('coche_educacion_clase', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .75
        }},
    'coche_salud_clase': feature => {
        const viewName = feature.properties['coche_salud_clase']
        return {
            fillColor: getColor('coche_salud_clase', viewName),
            weight: 2,
            opacity: 1,
            color: 'none',  // Outline color
            fillOpacity: .75
        }},
    'ndvi': feature => {
        const viewName = 5 - feature.properties['codigo']
            return {
            fillColor: getColor('distancia_peatonal', viewName),
            weight: 0,
            opacity: 1,
            fillOpacity: .7
        }},
})


